/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceEntryRequest } from './BalanceEntryRequest';
import {
    BalanceEntryRequestFromJSON,
    BalanceEntryRequestFromJSONTyped,
    BalanceEntryRequestToJSON,
    BalanceEntryRequestToJSONTyped,
} from './BalanceEntryRequest';
import type { ClaimCollateralRequest } from './ClaimCollateralRequest';
import {
    ClaimCollateralRequestFromJSON,
    ClaimCollateralRequestFromJSONTyped,
    ClaimCollateralRequestToJSON,
    ClaimCollateralRequestToJSONTyped,
} from './ClaimCollateralRequest';

/**
 * 
 * @export
 * @interface UpdateClaimRequest
 */
export interface UpdateClaimRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    representativeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    caseNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    legalBasis: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    disputedStatus: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    collateralStatus: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    expectedLossPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    claimEntirelyDisputed?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    recognizedAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    srvRegistrationStatus?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    srvOrderNumber?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimRequest
     */
    notes?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateClaimRequest
     */
    isCompleted?: boolean;
    /**
     * 
     * @type {Array<ClaimCollateralRequest>}
     * @memberof UpdateClaimRequest
     */
    collaterals?: Array<ClaimCollateralRequest>;
    /**
     * 
     * @type {Array<BalanceEntryRequest>}
     * @memberof UpdateClaimRequest
     */
    balanceEntries?: Array<BalanceEntryRequest>;
    /**
     * 
     * @type {Date}
     * @memberof UpdateClaimRequest
     */
    expectedBalanceListVersionUtc?: Date | null;
}

/**
 * Check if a given object implements the UpdateClaimRequest interface.
 */
export function instanceOfUpdateClaimRequest(value: object): value is UpdateClaimRequest {
    if (!('legalBasis' in value) || value['legalBasis'] === undefined) return false;
    if (!('disputedStatus' in value) || value['disputedStatus'] === undefined) return false;
    if (!('collateralStatus' in value) || value['collateralStatus'] === undefined) return false;
    return true;
}

export function UpdateClaimRequestFromJSON(json: any): UpdateClaimRequest {
    return UpdateClaimRequestFromJSONTyped(json, false);
}

export function UpdateClaimRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'representativeId': json['representativeId'] == null ? undefined : json['representativeId'],
        'caseNumber': json['caseNumber'] == null ? undefined : json['caseNumber'],
        'legalBasis': json['legalBasis'],
        'disputedStatus': json['disputedStatus'],
        'collateralStatus': json['collateralStatus'],
        'expectedLossPercent': json['expectedLossPercent'] == null ? undefined : json['expectedLossPercent'],
        'claimEntirelyDisputed': json['claimEntirelyDisputed'] == null ? undefined : json['claimEntirelyDisputed'],
        'recognizedAmount': json['recognizedAmount'] == null ? undefined : json['recognizedAmount'],
        'srvRegistrationStatus': json['srvRegistrationStatus'] == null ? undefined : json['srvRegistrationStatus'],
        'srvOrderNumber': json['srvOrderNumber'] == null ? undefined : json['srvOrderNumber'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'isCompleted': json['isCompleted'] == null ? undefined : json['isCompleted'],
        'collaterals': json['collaterals'] == null ? undefined : ((json['collaterals'] as Array<any>).map(ClaimCollateralRequestFromJSON)),
        'balanceEntries': json['balanceEntries'] == null ? undefined : ((json['balanceEntries'] as Array<any>).map(BalanceEntryRequestFromJSON)),
        'expectedBalanceListVersionUtc': json['expectedBalanceListVersionUtc'] == null ? undefined : (new Date(json['expectedBalanceListVersionUtc'])),
    };
}

export function UpdateClaimRequestToJSON(json: any): UpdateClaimRequest {
    return UpdateClaimRequestToJSONTyped(json, false);
}

export function UpdateClaimRequestToJSONTyped(value?: UpdateClaimRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'representativeId': value['representativeId'],
        'caseNumber': value['caseNumber'],
        'legalBasis': value['legalBasis'],
        'disputedStatus': value['disputedStatus'],
        'collateralStatus': value['collateralStatus'],
        'expectedLossPercent': value['expectedLossPercent'],
        'claimEntirelyDisputed': value['claimEntirelyDisputed'],
        'recognizedAmount': value['recognizedAmount'],
        'srvRegistrationStatus': value['srvRegistrationStatus'],
        'srvOrderNumber': value['srvOrderNumber'],
        'notes': value['notes'],
        'isCompleted': value['isCompleted'],
        'collaterals': value['collaterals'] == null ? undefined : ((value['collaterals'] as Array<any>).map(ClaimCollateralRequestToJSON)),
        'balanceEntries': value['balanceEntries'] == null ? undefined : ((value['balanceEntries'] as Array<any>).map(BalanceEntryRequestToJSON)),
        'expectedBalanceListVersionUtc': value['expectedBalanceListVersionUtc'] == null ? value['expectedBalanceListVersionUtc'] : value['expectedBalanceListVersionUtc'].toISOString(),
    };
}

